import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativePricedBrandInlineFields,
  CreativeFlightsPricedBrandInline,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getFlightsPricedBrandInlineCreative = (
  fields: ConductorCreativePricedBrandInlineFields,
): CreativeFlightsPricedBrandInline => {
  const {
    appIndex,
    callToActionText = null,
    carriersCriteria,
    checkoutType,
    deeplink = null,
    deeplinkParams = null,
    dimensions,
    excludedCarriers,
    includedCarriers,
    itineraryId = null,
    message,
    partner,
    partnerDesktopLogo,
    partnerLogo,
    pioAgencyName,
    pioPartnerName,
    redirectUrl,
    requestedDepth,
    selection,
    splitTestId,
    title,
    trackingModifications,
    useFlightsSkippyChannel,
  } = fields;

  return {
    appIndex,
    callToActionText,
    deeplink,
    deeplinkParams,
    itineraryId,
    message,
    partner,
    partnerDesktopLogo,
    partnerLogo,
    redirectUrl,
    removeDeeplinkIds: null,
    requestedDepth,
    selection,
    title,
    checkoutType,
    dimensions,
    trackingModifications,
    useFlightsSkippyChannel,
    format: ADVERT_FORMAT_TYPES.PRICED_BRAND_INLINE,
    carriersCriteria: carriersCriteria || 'all',
    includedCarriers: includedCarriers ? includedCarriers.split(',').map(Number) : [],
    excludedCarriers: excludedCarriers ? excludedCarriers.split(',').map(Number) : [],
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
